export const SET_ACCOUNT_COLLECTION = 'ACCOUNT/SET_ACCOUNT_COLLECTION';
